import type { IPricingFeatureDetailWithPlan } from '../../types';

import { PlanDetailItem } from './PlanDetailItem';
import { Fragment } from 'react';

export const PlanDetail = ({ detail }: { detail: IPricingFeatureDetailWithPlan }) => {
  return (
    <Fragment>
      {Object.entries(detail).map(([key, value]) => (
        <PlanDetailItem key={key} detail={value} />
      ))}
    </Fragment>
  );
};
